import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={4}
    height={8}
    fill="none"
    viewBox="0 0 4 8" {...props}
  >
    <path
      fill="#323232"
      d="M.313.979a.5.5 0 0 1 .67-.035L1.02.98l2.667 2.666.034.038a.5.5 0 0 1-.034.67L1.02 7.018a.5.5 0 1 1-.707-.707l2.313-2.313L.313 1.686.28 1.648a.5.5 0 0 1 .034-.67"
    />
  </svg>
);
export default SvgChevronRight;
